import { IOnboardingDocuments } from '@efex-services/documents/documentsSvc';
import { OnboardingDocumentTypeIds } from '@efex-services/documents/types';
import React, { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { NatureOfBusinessOptions } from './bussinesNature.config';

interface UseBussinesNature {
  onboardingDocuments: IOnboardingDocuments[];
}

const useBussinesNature = ({ onboardingDocuments }: UseBussinesNature) => {
  const { setValue, watch } = useFormContext();

  const hasForeignOperations = watch('hasForeignOperations');

  const [showBusinessNature, setShowBusinessNature] = useState({
    yes: false,
    no: false,
  });

  useEffect(() => {
    setShowBusinessNature({
      yes: hasForeignOperations,
      no: !hasForeignOperations,
    });
  }, [hasForeignOperations]);

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, checked } = event.target;

    if (checked) {
      const isEnabled = name === NatureOfBusinessOptions.YES;

      setShowBusinessNature({
        yes: isEnabled,
        no: !isEnabled,
      });

      setValue('hasForeignOperations', isEnabled);
    }
  };

  useEffect(() => {
    const bussinesNatureDocument = onboardingDocuments?.filter(
      (element) =>
        element.document.type.id === OnboardingDocumentTypeIds.businessNature
    );

    if (bussinesNatureDocument?.length) {
      setShowBusinessNature({
        yes: true,
        no: false,
      });
      setValue('hasForeignOperations', true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onboardingDocuments]);

  return { showBusinessNature, handleCheckboxChange };
};

export default useBussinesNature;
